import { render, staticRenderFns } from "./IconSvgDSEALegislativeAction.vue?vue&type=template&id=5b819cfe&scoped=true&"
import script from "./IconSvgDSEALegislativeAction.vue?vue&type=script&lang=js&"
export * from "./IconSvgDSEALegislativeAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b819cfe",
  null
  
)

export default component.exports